import { create } from 'zustand';

type BillingBlockState = {
  blocked: boolean;
  setBlocked: (blocked: boolean) => void;
};

/**
 * Set when any API call returns 402 PAYMENT_REQUIRED (the backend billing gate —
 * lapsed / unsubscribed / expired-trial agency); cleared on the next successful
 * response. A top-level screen prompts the agency to subscribe while this is
 * true. Mirrors `useSuspensionStore`; suspension takes precedence over this.
 * In-memory only — a page reload resets it (the first request then re-evaluates).
 */
export const useBillingBlockStore = create<BillingBlockState>((set) => ({
  blocked: false,
  setBlocked: (blocked) => set({ blocked }),
}));
